exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js!viewerjs/dist/viewer.css"), "");

// Module
exports.push([module.id, "\n", ""]);

